import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from '@mui/material';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import React, { useEffect, useContext } from 'react';
import RequestHourFilter from './RequestHourFilter';
import RequestsTable from './RequestsTable';
import { DesignContext } from '../../context/DesignContext';
import { DjContext } from '../../context/DjContext';
import './djPage.css';
import RequestFilterBanners from './RequestFilterBanners';

const refreshIntervalOptions = [
  { label: '5 seconds', value: 5_000 },
  { label: '15 seconds', value: 15_000 },
  { label: '1 minute', value: 60_000 },
  { label: '5 minutes', value: 300_000 },
  { label: '15 minutes', value: 900_000 },
];

const DjPage = () => {
  const { setShowHeader } = useContext(DesignContext);
  const {
    handleRefreshRequests,
    songFetchLoading,
    startRefreshLoop,
    stopRefreshLoop,
    setRefreshInterval,
    refreshInterval,
  } = useContext(DjContext);

  useEffect(() => {
    setShowHeader(false);
    return () => {
      setShowHeader(true);
    };
  }, []);

  useEffect(() => {
    startRefreshLoop();
    return () => {
      stopRefreshLoop();
    };
  }, [refreshInterval])

  function handleChangeRefreshInterval(event) {
    setRefreshInterval(event.target.value);
  }

  return (
    <Box
      sx={{
        padding: { xs: '0.3rem', sm: '1rem' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'top',
          gap: 2,
          paddingBottom: '1rem',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 1,
          }}
        >
          <Typography
            variant='h4'
            noWrap
            sx={{
              margin: 0,
            }}
          >
            Song Requests
          </Typography>
          <Tooltip title='Refresh song requests'>
            <IconButton
              onClick={handleRefreshRequests}
              disabled={songFetchLoading}
            >
              <RefreshRoundedIcon />
            </IconButton>
          </Tooltip>

          <FormControl>
            <InputLabel id='time-range-select-label'>Time Range</InputLabel>
            <Select
              labelId='time-range-select-label'
              id='time-range-select'
              value={refreshInterval}
              label='Time Range'
              onChange={handleChangeRefreshInterval}
              size='small'
            >
              {refreshIntervalOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <RequestHourFilter />
      </Box>

      <RequestFilterBanners />

      <RequestsTable />
    </Box>
  );
};

export default DjPage;
